import { useEffect } from 'react';

const UpdateTitle = ({ newTitle, originalTitle }) => {
  useEffect(() => {
    // Store the original title
    const prevTitle = document.title;

    // Update the title when the component mounts
    document.title = newTitle;

    // Restore the original title when the component unmounts
    return () => {
      document.title = prevTitle;
    };
  }, [newTitle, originalTitle]);

  return null; // This component doesn't render anything
};

export default UpdateTitle;


// WEBPACK FOOTER //
// ./src/components/updateTitle/UpdateTitle.jsx